import { Component, ElementRef, HostListener, Inject, OnInit, Renderer2, ViewChild } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { PreviewFileConfig } from 'src/app/model/preview-file.model';

@Component({
  selector: 'app-open-image-dialog',
  templateUrl: './open-image-dialog.component.html',
  styleUrls: ['./open-image-dialog.component.css'],
})
export class OpenImageDialogComponent implements OnInit {
  @ViewChild('imageContainer') imageContainer: ElementRef;
  @ViewChild('image') image: ElementRef;
  imageURL: string = null;
  fileName: string = null;
  showZoomLevel: boolean = false;
  scaleValue = 1;
  zoomDifference: number = 0.25;
  minimumZoom: number = 1;
  maximumZoom: number = 4;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PreviewFileConfig,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.imageURL = this.data.filePath;
    this.fileName = this.data.displayName;
  }

  @HostListener('wheel', ['$event'])
  onWheelScroll(event: WheelEvent): void {
    if (event.ctrlKey) {
      if (event.deltaY > 0) {
        this.imageZoomOut();
      } else {
        this.imageZoomIn();
      }
      event.preventDefault();
    }
  }

  imageZoomIn(): void {
    if (this.scaleValue < this.maximumZoom) {
      this.scaleValue += this.zoomDifference;
      this.renderer.setStyle(this.image.nativeElement, 'zoom', this.scaleValue);
      this.showZoomTemporarily();
    }
  }

  imageZoomOut(): void {
    if (this.scaleValue > this.minimumZoom) {
      this.scaleValue -= this.zoomDifference;
      this.renderer.setStyle(this.image.nativeElement, 'zoom', this.scaleValue);
      this.showZoomTemporarily();
    }
  }

  toggleZoomInZoomOut(): void {
    this.scaleValue = this.scaleValue === this.maximumZoom ? this.minimumZoom : this.maximumZoom;
    this.renderer.setStyle(this.image.nativeElement, 'zoom', this.scaleValue);
    this.showZoomTemporarily();
  }

  showZoomTemporarily(): void {
    this.scrollToVerticallyMiddle();
    this.scrollToHorizontallyMiddle();
    this.showZoomLevel = true;
    const timer = setTimeout(() => {
      this.showZoomLevel = false;
      clearTimeout(timer);
    }, 1500);
  }

  private scrollToHorizontallyMiddle(): void {
    if (this.imageContainer && this.imageContainer.nativeElement) {
      const containerWidth = this.imageContainer.nativeElement.offsetWidth;
      const scrollWidth = this.imageContainer.nativeElement.scrollWidth;
      const middleScroll = (scrollWidth - containerWidth) / 2;
      this.imageContainer.nativeElement.scrollLeft = middleScroll;
    }
  }

  private scrollToVerticallyMiddle(): void {
    if (this.imageContainer && this.imageContainer.nativeElement) {
      const containerHeight = this.imageContainer.nativeElement.offsetHeight;
      const scrollHeight = this.imageContainer.nativeElement.scrollHeight;
      const middleScroll = (scrollHeight - containerHeight) / 2;
      this.imageContainer.nativeElement.scrollTop = middleScroll;
    }
  }
}
